import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useHistory } from 'react-router-dom';
import { useCookies } from 'react-cookie';
import PrimaryContainer from '../../customUI/PrimaryContainer';
import PrimaryButton from '../../customUI/PrimaryButton';
import { authActions } from '../../store/auth-reducer';
import { websiteSwitchActions } from '../../store/website-switch-reducer';
import { websiteAnalyticsActions } from '../../store/website-analytics-reducer';
import { leadsActions } from '../../store/leads-reducer';
import { contentActions } from '../../store/content-reducer';
import { storeContext } from '../provider/Provider';

const { REACT_APP_AUTH0_URL, REACT_APP_AUTH0_CLIENT_ID } = process.env;

const useStyles = makeStyles((theme) => ({
  container: {
    padding: 20,
    minHeight: 'unset',
    width: '40%',
    textAlign: 'center',
    color: '#696969',
    [theme.breakpoints.down('sm')]: {
      width: '90%',
    },
  },
  heading: {
    margin: 0,
    marginTop: 25,
    color: '#696969',
    fontWeight: 700,
  },
  message: {
    marginTop: 15,
  },
  button: {
    marginTop: 30,
  },
}));

const NoWebsites = () => {
  const [cookies] = useCookies(['auth']);
  const history = useHistory();
  const { dispatch } = React.useContext(storeContext);
  const classes = useStyles();

  const handleLogout = () => {
    dispatch({ type: authActions.LOGOUT });
    dispatch({ type: websiteSwitchActions.CLEAN_WEBSITE_SWITCH });
    dispatch({ type: websiteAnalyticsActions.WEBSITE_ANALYTICS_CLEAN });
    dispatch({ type: leadsActions.LEADS_CLEAN });
    dispatch({ type: contentActions.CONTENT_CLEAN });
    window.location.href = `${REACT_APP_AUTH0_URL}/logout?client_id=${REACT_APP_AUTH0_CLIENT_ID}&returnTo=${window.location.origin}`;
  };

  const handleSupport = () => {
    window.open(
      'https://hennessey.zendesk.com/hc/en-us/requests',
      '_blank'
    );
  };

  if (!cookies.id_token) {
    history.push('/');
  }

  return (
    <PrimaryContainer className={classes.container}>
      <h1 className={classes.heading}>No websites found.</h1>
      <div className={classes.message}>
        You currently do not have a website connected to the HD Platform to view. If this message is
        in error, please contact your account manager to assist in correcting your account.
      </div>
      <div className={classes.button}>
        <PrimaryButton
          variant="contained"
          component="span"
          color="primary"
          data-testid="sub_button_test_id"
          style={{ marginRight: 20 }}
          onClick={handleSupport}
          aria-label="support btn"
        >
          Support
        </PrimaryButton>
        <PrimaryButton
          variant="contained"
          component="span"
          color="secondary"
          data-testid="unsub_button_test_id"
          style={{ marginLeft: 20 }}
          onClick={handleLogout}
          aria-label="logOut btn"
        >
          Log Out
        </PrimaryButton>
      </div>
    </PrimaryContainer>
  );
};

export default NoWebsites;
